import { useApi } from '@/api';
import {
  ActivityCard,
  EntityName,
  ExternalLinkIcon,
  KpiCard,
  Link,
  LinkButton,
  Page
} from '@/components';
import UpgradeIcon from '@/components/icons/UpgradeIcon';
import { useSearchParams } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';
import {
  ArrowSwitchIcon,
  CryptoIcon,
  Flex,
  Heading,
  LinkWrapper
} from '@blockanalitica/ui';
import CallersDonutChart from './CallersDonutChart';
import HistoricTabs from './HistoricTabs';
import TopCallers from './TopCallers';
import TopWallets from './TopWallets';
import WalletsDonutChart from './WalletsDonutChart';

export default function UpgradeUSDSPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');

  const [data, error] = useApi({
    url: '/upgrade/usds/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name="DAI"
                address={tokensMapping('DAI').address}
                size="3"
              />
            }
            symbol2={
              <CryptoIcon
                name="USDS"
                address={tokensMapping('USDS').address}
                size="3"
              />
            }>
            <Heading size="1">
              <Flex gap="xs" alignItems="center">
                DAI <ArrowSwitchIcon /> USDS
              </Flex>
            </Heading>
          </EntityName>
        }
        actions={
          <>
            <LinkButton
              to="https://app.sky.money/?widget=upgrade&source_token=DAI"
              target="_blank">
              <Flex
                gap="3xs"
                alignItems="center"
                style={{ whiteSpace: 'nowrap' }}>
                <UpgradeIcon size="1" /> Upgrade to USDS
                <ExternalLinkIcon size="1" />
              </Flex>
            </LinkButton>
          </>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            variant="usds"
            title="Upgrated from DAI to USDS"
            data={data}
            field="balance"
            options={{
              currency: tokensMapping('USDS')
            }}
          />
        </Flex>

        <HistoricTabs />

        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <Flex gap={['m', 's']} flexDirection="column" width="100%">
            <LinkWrapper
              to="wallets"
              // @ts-ignore
              as={Link}
              variant="kpiCardLinkWithBlendMode">
              <KpiCard
                title="N° of Wallets"
                data={data}
                field="number_of_wallets"
                options={{
                  linkArrow: true,
                  variants: { valuePercentageValue: 'dynamic' }
                }}
              />
            </LinkWrapper>
            <TopWallets flexBasis="100%" />
          </Flex>

          <Flex flexBasis="100%" flexDirection="column" alignItems="center">
            <Heading size="3">Wallets Distribution</Heading>
            <WalletsDonutChart />
          </Flex>
        </Flex>
        <ActivityCard url={`/upgrade/usds/activity/`} linkTo="activity" />

        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <Flex gap={['m', 's']} flexDirection="column" width="100%">
            <LinkWrapper
              to="callers"
              // @ts-ignore
              as={Link}
              variant="kpiCardLinkWithBlendMode">
              <KpiCard
                title="N° of Callers"
                data={data}
                field="number_of_callers"
                options={{
                  linkArrow: true,
                  variants: { valuePercentageValue: 'dynamic' }
                }}
              />
            </LinkWrapper>
            <TopCallers flexBasis="100%" />
          </Flex>

          <Flex flexBasis="100%" flexDirection="column" alignItems="center">
            <Heading size="3">Callers Distribution</Heading>
            <CallersDonutChart />
          </Flex>
        </Flex>
      </Page>
    );
  }

  return null;
}
